module.exports = __webpack_public_path__ + "static/media/otherStaff.422b27f2.svg";